import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { ContractZone } from '../../_types/contract-zone';
import { ContractZoneLine } from '../../_types/contract-zone-line';
import { ContractZonesService } from '../../_services/contracts-zones.service';
import { ContractZonesLinesService } from '../../_services/contracts-zones-lines.service';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ZonesService } from 'src/app/modules/zones/_services/zones.service';
import { Country } from 'src/app/modules/common/_types/country';
import { CountryRegion } from 'src/app/modules/common/_types/country-region';
import { CountriesService } from 'src/app/modules/common/_services/countries.service';
import { CountriesRegionsService } from 'src/app/modules/common/_services/countries-regions.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-contract-zones-detail',
    templateUrl: './zones-detail.component.html',
    styleUrls: ['./zones-detail.component.css'],
    standalone: false
})
export class ContractZonesDetailComponent implements OnInit {
  
  public zoneFormGroup!: RxFormGroup;
  //public zoneLineFormGroup!: RxFormGroup;

  public contractZone: ContractZone = new ContractZone();  
  public loading: boolean = false;  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public contractZoneLines: any = [];
  public visibleContractZoneLine:boolean = false;
  public contractZoneLine: ContractZoneLine = new ContractZoneLine();
  public zones: any[]=[];
  public selectedZonesIds: any[]=[];
  public countries: Country[] = [];
  public countriesRegions: CountryRegion[] = [];
  public countryId?: string;
  public countryRegionId?: string;

  constructor(
    private config: DynamicDialogConfig,
    private contractZonesService: ContractZonesService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,     
    private contractZonesLinesService: ContractZonesLinesService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private zonesService: ZonesService ,
        private countriesService: CountriesService,
        private countriesRegionsService: CountriesRegionsService,  
        private loginService: LoginService       
  ) {    

    this.zoneFormGroup = this.formBuilder.formGroup<ContractZone>(this.contractZone) as RxFormGroup;
    ////this.zoneLineFormGroup = this.formBuilder.formGroup<ContractZoneLine>(this.contractZoneLine) as RxFormGroup;
  }
  

  ngOnInit(): void {
    this.loadZones();
    this.loadCountries();
    this.contractZone.contractId = this.config.data.contractId;
        
    if(this.config.data.id!=null && this.config.data.id!='0'){
      this.loadContractZone(this.config.data.id);
    }
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }
  
  async loadContractZone(id: string) {
    this.contractZone = await firstValueFrom(this.contractZonesService.get(id));
    this.zoneFormGroup.patchValue(this.contractZone);   
    this.loadContractZoneLines();
  }

  async load(event: any){
    if(event.filter.length > 2) this.loadZones(event.filter);
  }
  
  async loadCountries() {
    let params: IParamsCollection = {
      page: {
        size: 1000
      },
      sort: [ 'name' ]
    }
    let response = await firstValueFrom(this.countriesService.all(params));
    this.countries = response.data;
    this.countryId = this.countries.filter((m:any) => m.code == "ES").map((m:any) => m.id)[0] || null;
    this.zoneFormGroup.patchValue({countryId: this.countryId});   
  }

  onCountryChange(event: any) {
    let countryId = event.value;
    this.loadCountryRegions(countryId);
    this.loadZones();
  }

  async loadCountryRegions(countryId: string | null = null) {
    let params: IParamsCollection = {
      page: {
        size: 1000
      },
      sort: [ 'name' ]
    }
    if(countryId){
      let filters: any = {
        countryId: new Filter(FilterOperation.equals, "countryId", '', countryId)
      };
      params.filter = FilterBuilder.fromObject(filters).build();
    }
    let response = await firstValueFrom(this.countriesRegionsService.all(params));
    this.countriesRegions = response.data;
  }

  onCountryRegionChange(event: any){
    this.countryRegionId = event.value;
    this.loadZones();
  }

  async loadZones(filter: string = "") {

    let filters = {
      name: new Filter(FilterOperation.contains, 'name'), 
      id: new Filter(FilterOperation.equals, 'id'),
      countryId: new Filter(FilterOperation.equals, 'countryId', ''),
      countryRegionId: new Filter(FilterOperation.equals, 'countryRegionId', ''),
    };
    if(this.contractZone && this.contractZone.zoneId != null){
        filters.id= new Filter(FilterOperation.equals, 'id', "", this.contractZone.zoneId)
    }
    if(this.countryId != null){
      filters.countryId = new Filter(FilterOperation.equals, 'countryId', "", this.countryId);
    }

    if(this.countryRegionId != null){
      filters.countryRegionId = new Filter(FilterOperation.equals, 'countryRegionId', "", this.countryRegionId);
    }

    if(filter && filter != ""){
      filters.name = new Filter(FilterOperation.contains, 'name', "", filter);
    }

    let response = await firstValueFrom(this.zonesService.all({filter: FilterBuilder.fromObject(filters).build() ,page: {number: 1, size: 100}, sort: ['name']}));
    this.zones = response.data;

    //this.zones.concat(this.selectedZonesIds);
    this.selectedZonesIds.forEach((item: any)=>{ 
      if(this.zones.findIndex((model:any) => model.id == item.id) == -1) this.zones.push(item)
    });

  }
  
  async loadContractZoneLines() {

    let filters = {
      contractZoneId: new Filter(FilterOperation.equals, 'contractZoneId', '', this.contractZone.id!)
    };
    
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.contractZonesLinesService.all(params));

    this.contractZoneLines = response.data;
    
  }

  async save() {

    let valid = this.formValidationService.validateForm(this.zoneFormGroup);
    if (valid) {
      for (const element of this.selectedZonesIds) {
        var c = new ContractZone();
        c.zoneId = element.id;
        c.contractId = this.contractZone.contractId;
        let contractZone: any = await firstValueFrom(this.contractZonesService.save(c));
      }

     // if(this.contractZone.id){
        this.dynamicDialogRef.close();
     /* }else{
        this.loadContractZone(contractZone.id);
      } */

      this.messageService.add({ closable: true, severity: 'success', detail: "Zona guardada correctamente" });
    }else{
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });    
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Quieres eliminar la zona " + this.contractZone.zone?.name+ "?",
      header: "Eliminar zona",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractZonesService.delete(this.contractZone.id).subscribe(
          (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Zona eliminada correctamente" });

            this.cancel();
          },
          (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }
/*
  editContractZoneLine(contracZoneLine: any) {         
    this.contractZoneLine = contracZoneLine;    
    if(contracZoneLine.id != null) {      
      this.zoneLineFormGroup.patchValue(this.contractZoneLine);   
    }
    this.visibleContractZoneLine = true;    
  }

  async saveContractZoneLine(){
    this.visibleContractZoneLine = false;
    let id:string = this.contractZone.id!;
    let valid = this.formValidationService.validateForm(this.zoneLineFormGroup);
    if (valid) {
      this.contractZoneLine = Object.assign(this.contractZoneLine, this.zoneLineFormGroup.value);  
      this.contractZoneLine.contractZoneId = id;
      await firstValueFrom(this.contractZonesLinesService.save(this.contractZoneLine));
    }
    
    this.loadContractZoneLines();
  }

  deleteContractZoneLine(contractZoneLine: any) {    
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la línea"+contractZoneLine.value+"?",
        header: "Eliminar línea",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.contractZonesLinesService.delete(contractZoneLine.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Línea eliminada correctamente" });
              this.loadContractZoneLines();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }*/

}
